import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { showToast } from '../config/Alert';
import { Row, Col, Form, Button } from 'react-bootstrap';
import Slider from "react-slick";
import login from "../assets/images/login.webp";
import login1 from "../assets/images/login1.webp";
import login2 from "../assets/images/login2.webp";
import { loginApi } from '../services/AuthApi';

const Login = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ email: "", password: "" });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const validateForm = () => {
        let errors = {};
        if (!formData.email) {
            errors.email = "Email is required";
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(formData.email)) {
                errors.email = "Invalid email format";
            }
        }
        if (!formData.password) errors.password = "Password is required";
        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validateForm();
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length === 0) {
            setLoading(true);
            try {
                const response = await loginApi(formData);
                showToast("Login successful!", "success");
                localStorage.setItem("token", response.token);
                localStorage.setItem("user", JSON.stringify(response.user));
                const role = response.user.role;
                if (role === "Teacher") {
                    navigate("/teacherDashboard");
                } else if (role === "Parent") {
                    navigate("/dashboard");
                } else {
                    navigate("/"); // default fallback
                }
            } catch (error) {
                showToast(error || "Login failed. Please try again.", 'error');
            } finally {
                setLoading(false);
            }
        }
    };


    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000
    };

    return (
        <div className='login-form'>
            <Slider className='login_Items' {...settings}>
                <div>
                    <img src={login} alt="login" className='img-fluid' />
                    <Row className='justify-content-center mt-4'>
                        <Col xs='10' md='11' className='fs-12' >
                            <h4 className='text-danger fw-7 fs-18'>Hear the Call</h4>
                            <p>Long ago, a Piper's tune sparked a magical advanture.
                                Today, The Pied Piper calls your child to explore a world of creativity, curiosity, and endless possibilities.
                            </p>
                        </Col>
                    </Row>
                </div>
                <div>
                    <img src={login1} alt="login" className='img-fluid' />
                    <Row className='justify-content-center mt-4'>
                        <Col xs='10' md='11' className='fs-12' >
                            <h4 className='text-danger fw-7 fs-18'>Begin the Adventure</h4>
                            <p>The Melody awaits!</p>
                            <p>Choose your courses, and let the story unfold.</p>
                            <p className='fw-bold'>Are you ready to follow the piper?</p>
                        </Col>
                    </Row>
                </div>
                <div>
                    <img src={login2} alt="login" className='img-fluid' />
                    <Row className='justify-content-center mt-4'>
                        <Col xs='10' md='11' className='fs-12' >
                            <h4 className='text-danger fw-7 fs-18'>Discover New Paths</h4>
                            <p>Follow the Piper to uncover passions--art, music, theatre, dance, debate, and more. Each step leads to mastering skill and creating lifelong memories.</p>
                        </Col>
                    </Row>
                </div>
            </Slider>
            <div className='login_main_form bg_light_yellow rounded-top-5 mt-5'>
                <h2 className='fs-20'>Sign In</h2>
                <div className='d-flex justify-content-between align-items-center'>
                    <h6 className='fs-10'>Don't have an account?</h6>
                    <p><Link to='/signup' className='fw-bold text-decoration-none text-black fs-10'>Get One</Link></p>
                </div>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="email">
                        <Form.Control
                            type="email"
                            name='email'
                            size='lg'
                            className='border-2 border-secondary'
                            placeholder='Email'
                            value={formData.email}
                            onChange={handleChange}
                        />
                        {errors.email && <small className="text-danger">{errors.email}</small>}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="password">
                        <Form.Control
                            type="password"
                            name='password'
                            size='lg'
                            className='border-2 border-secondary'
                            placeholder='Password'
                            value={formData.password}
                            onChange={handleChange}
                        />
                        {errors.password && <small className="text-danger">{errors.password}</small>}
                    </Form.Group>
                    <div className='d-flex justify-content-between align-items-center'>
                        <h6><Link to='/forgotPassword' className='text-decoration-none text-black fs-10'>Forgot Password?</Link></h6>
                    </div>
                    <Form.Group className='text-center'>
                        <Button variant="info" size='lg' type="submit" className='px-5 text-white border-2 border-secondary' disabled={loading}>
                            {loading ? 'Signing In...' : 'Sign In'}
                        </Button>
                    </Form.Group>
                </Form>
            </div>
        </div >
    );
}

export default Login;
